import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Home from "../Home";
import Breadcrumb from "../../components/Breadcrumb";
import { Accordion, Card, Spinner, Modal } from "react-bootstrap";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import {
  fetchEmployeeName,
  fetchOrganizationList,
  fetchEmployeeData,
  fetchEmployee,
  fetchTargetPeriod,
} from "./actions";
import { fetchEmployeeListing } from "./actions";
import { LOAD_MORE_PAGE_SIZE } from "../../constants/pagination";

function SearchMembers() {
  const [lang] = useTranslation("language");
  var personName = sessionStorage.getItem("Kanji name");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const employeeDetails = useSelector(
    (state) => state.salesReport.employeeList
  );
  const noEmp = useSelector((state) => state.salesReport.noEmployee);
  const [allChecked, setAllChecked] = useState(false);
  const [processingDate, setProcessingDate] = useState("");
  const [personInCharge, setPersonInCharge] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [wwid, setWWID] = useState("");
  const [name, setName] = useState("");
  const [page, setPage] = useState("");
  const [orgId, setOrgId] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [fromDateDisplay, setFromDateDisplay] = useState("");
  const [toDateDisplay, setToDateDisplay] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [noData, setNoData] = useState(false);
  const [noEmployeeData, setNoEmployeeData] = useState(false);
  const [limit, setLimit] = useState(LOAD_MORE_PAGE_SIZE);
  const [loading, setLoading] = useState(false);
  const [employeeLoading, setEmployeeLoading] = useState(false);
  const [lazyLoading, setLazyLoading] = useState(false);

  const [orgLoading, setOrgLoading] = useState(false);
  const [loginName, setLoginName] = useState("");
  const [total, setTotal] = useState(0);
  const [isCheckBoxSelected, setIsCheckBoxSelected] = useState([]);
  const [isEmployeeCheckBoxSelected, setIsEmployeeCheckBoxSelected] = useState(
    []
  );
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [organizationList, setOrganizationList] = useState([]);

  const options = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];

  const [sortWWID, setSortWWID] = useState("asc");
  const [sortPersonInCharge, setSortPersonInCharge] = useState("asc");
  const [sortAffiliation, setSortAffiliation] = useState("asc");

  useEffect(() => {
    const state = location.state || {};
    let page = state.page || "";
    setPage(page);
    getOrganizationList();
    setPersonInCharge(sessionStorage.getItem("WWID"));
    setOrganizationName(sessionStorage.getItem("Organization name"));
    let name = sessionStorage.getItem("Kanji name");
    setLoginName(name);
    getTargetPeriod();
  }, [location]);

  const handleCloseErrorMessage = () => setShowErrorMessage(false);

  /*** 
    @purpose : Get target period
    @Parameter : {}
    **/
    const getTargetPeriod = async () => {
      let page = "";
      const state = location.state || {};
      const pageName = state.page || "";
      
      if(pageName === "selloutFacility") {
        page = "selloutRotation"
      } else if(pageName === "selloutWholesaler") {
        page = "selloutRotationCA"
      } else {
        page = pageName
      }
      await fetchTargetPeriod(page).then((response) => {
        setFromDate(
          response && response.from_date ? response.from_date.split("/").join("") : ""
        );
        setToDate(response && response.to_date ? response.to_date.split("/").join("") : "");
        setFromDateDisplay(response && response.from_date ? response.from_date : "");
        setToDateDisplay(response && response.to_date ? response.to_date : "");
        setProcessingDate(
          response && response.processing_date ? response.processing_date : ""
        );
      });
    };

  const getOrganizationList = async () => {
    setOrgLoading(true);
    await fetchOrganizationList().then((response) => {
      setOrgLoading(false);
      let newList = [];
      for (let index = 0; index < response.length; index++) {
        const item = response[index];
        newList.push({
          value: item.org_code,
          label: item.org_abbr_jp,
        });
      }
      setOrganizationList(newList);
    });
  };

  /*** 
  @purpose : Handle checkbox
  @Parameter : {e}
  **/
  const handleCheckbox = (e) => {
    let tempListing = [...employeeList];
    let selected = [];
    let checkedAll = allChecked;

    if (e.target.value === "checkAll") {
      tempListing.forEach((item) => {
        item.isChecked = e.target.checked;
        checkedAll = e.target.checked;
      });
    } else {
      const foundEmployee = tempListing.find(({ wwid }) => wwid === e.target.value);
      if (foundEmployee) {
        foundEmployee.isChecked = e.target.checked;
        let newList = tempListing.filter((el) => el.isChecked === false);
        if (newList.length <= 0) {
          checkedAll = true;
        } else {
          checkedAll = false;
        }
      }
    }
    setEmployeeList(tempListing);
    setAllChecked(checkedAll);
    setIsCheckBoxSelected(tempListing.filter((el) => el.isChecked === true));
  };

  /*** 
  @purpose : Handle checkbox
  @Parameter : {e}
  **/
  const handleEmployeeCheckbox = (e) => {
    let tempListing = [...employeeData];
    let selected = [];
    let checkedAll = allChecked;

    if (e.target.value === "checkAll") {
      tempListing.forEach((item) => {
        item.isChecked = e.target.checked;
        checkedAll = e.target.checked;
      });
    } else {
      const foundEmployee = tempListing.find(({ wwid }) => wwid === e.target.value);
      if (foundEmployee) {
        foundEmployee.isChecked = e.target.checked;
        let newList = tempListing.filter((el) => el.isChecked === false);
        if (newList.length <= 0) {
          checkedAll = true;
        } else {
          checkedAll = false;
        }
      }
    }
    setEmployeeData(tempListing);
    setAllChecked(checkedAll);
    setIsEmployeeCheckBoxSelected(
      tempListing.filter((el) => el.isChecked === true)
    );
  };

  const handleSelect = () => {
    dispatch(fetchEmployeeData({ page: page, data: isCheckBoxSelected }));
    navigate(-1);
  };

  const handleEmployeeSelect = () => {
    dispatch(
      fetchEmployeeData({ page: page, data: isEmployeeCheckBoxSelected })
    );
    navigate(-1);
  };

  const handleSelectAll = () => {
    dispatch(fetchEmployeeData({ page: page, data: employeeList }));
    navigate(-1);
  };

  const handleReset = () => {
    let list = [...employeeList];
    var result = list.map(function (el) {
      var o = Object.assign({}, el);
      o.isChecked = false;
      return o;
    });
    setEmployeeList(result);
    setAllChecked(false);
  };

  /***
   @purpose : Handle sorting
   @Parameter : {obj}
   **/
  const handleSortingData = (obj) => {
    obj.column === "wwid" &&
    setSortWWID(obj.sortOrder);
    obj.column === "name_kanji" &&
    setSortPersonInCharge(obj.sortOrder);
    obj.column === "order" && setSortAffiliation(obj.sortOrder);
    let list = compareBySortedData(obj);
    setEmployeeList(list);
  };

  /***
   @purpose : Compare sorted data
   @Parameter : {obj}
   **/
  const compareBySortedData = (obj) => {
    const sorted = employeeList.sort((a, b) => {
      const isReversed = obj.sortOrder === "asc" ? 1 : -1;
      let first = a[obj.column] ? a[obj.column] : "";
      let second = b[obj.column] ? b[obj.column] : "";
      if (typeof first !== 'string' && !(typeof first === 'number' && isNaN(first))) {
        first = first.toString();
      }
      if (typeof second !== 'string' && !(typeof second === 'number' && isNaN(second))) {
        second = second.toString();
      }
      return isReversed * first.localeCompare(second);
    });
    return sorted;
  };

  const goToPrevious = () => {
    navigate(-1);
  };

  const handleOrgChange = (value) => {
    if (value) {
      setOrgId(value.value);
    } else {
      setOrgId("");
    }
  };

  const getEmployeeByWwid = async () => {
    setEmployeeLoading(true);
    setNoEmployeeData(false);
    setNoData(false);
    setEmployeeData([]);
    setEmployeeList([]);
    await fetchEmployee(wwid).then((response) => {
      setEmployeeLoading(false);
      if (response.success === true && response.data.length > 0) {
        var result =
          response &&
          response.data.map(function (el) {
            var o = Object.assign({}, el);
            o.isChecked = false;
            return o;
          });

        setEmployeeData(result);
        setNoEmployeeData(false);
      } else if (
        (response.success === true && response.data.length === 0) ||
        response.success === false
      ) {
        setEmployeeLoading(false);
        setNoEmployeeData(true);
        setEmployeeData([]);
      }
      if (response.data.length > 0) {
        var result =
          response &&
          response.data.map(function (el) {
            var o = Object.assign({}, el);
            o.isChecked = false;
            return o;
          });
        setEmployeeData(result);
      }
    });
  };

  const getEmployeeListing = async () => {
    setLoading(true);
    setNoEmployeeData(false);
    setEmployeeData([]);
    setEmployeeList([]);
    setNoData(false);
    let body = {
      // wwid: wwid,
      name_kanji: name,
      org_code: orgId,
      limit: LOAD_MORE_PAGE_SIZE
    };
    await fetchEmployeeListing(body).then((response) => {
      if (response.success === true && response.data.data.length > 0) {
        setLoading(false);
        var result =
          response &&
          response.data.data.map(function (el) {
            var o = Object.assign({}, el);
            o.isChecked = false;
            return o;
          });
        let count = response.data.total_count.split(",");
        setEmployeeList(result);
        setTotal(parseInt(count.join("")));
        setLimit(LOAD_MORE_PAGE_SIZE * 2)
        setNoData(false);
      } else if (
        (response.success === true && response.data.data.length === 0) ||
        response.success === false
      ) {
        setLoading(false);
        setTotal();
        setNoData(true);
      }
      // if (response.data.data.length > 0) {
      //   var result =
      //     response &&
      //     response.data.data.map(function (el) {
      //       var o = Object.assign({}, el);
      //       o.isChecked = false;
      //       return o;
      //     });
      //   setEmployeeList(result);
      //   setTotal(response.data.total_count)
      // }
    });
  };

  const handleContainerOnBottom = async () => {
    let body = {
      wwid: wwid,
      name_kanji: name,
      org_code: orgId,
      limit: limit,
    };
    if (employeeList.length < total && total >= LOAD_MORE_PAGE_SIZE) {
      await fetchEmployeeListing(body).then((response) => {
        let list = [];
        var result =
          response &&
          response.data.data.map(function (el) {
            var o = Object.assign({}, el);
            o.isChecked = false;
            return o;
          });
        list = employeeList.concat(result);
        setEmployeeList(list);
      });
      setLimit(limit + LOAD_MORE_PAGE_SIZE);
    }
  };

  const loadRecords = async () => {
    let body = {
      wwid: wwid,
      name_kanji: name,
      org_code: orgId,
      limit: limit,
    };
    if (employeeList.length < total && total >= LOAD_MORE_PAGE_SIZE) {
      setLazyLoading(true);

      await fetchEmployeeListing(body).then((response) => {
        let list = [];
        var result =
          response &&
          response.data.data.map(function (el) {
            var o = Object.assign({}, el);
            o.isChecked = false;
            return o;
          });
        list = employeeList.concat(result);
        setEmployeeList(list);
        setLazyLoading(false);
      });
      setLimit(limit + LOAD_MORE_PAGE_SIZE);
    }
  };


  return (
    <Home>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            {lang("dailySellout.searchMembers")}
          </Accordion.Header>
          <Accordion.Body>
            <div className="user-details">
              <div className="row">
                <div className="col-md-4">
                  {lang("dailySellout.processingDate")}: {processingDate}
                </div>
              </div>
            </div>
            <div className="horizon-form">
              <div className="custom-3">
                <label>{lang("dailySellout.wwidSpecify")}</label>
              </div>
              <div className="custom-9">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        value={wwid}
                        onChange={(e) => setWWID(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <button
                      className="btn btn-primary"
                      onClick={getEmployeeByWwid}
                      disabled={wwid === ""}
                    >
                      {lang("dailySellout.choice")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="horizon-form">
              <div className="custom-3">
                <label>{lang("dailySellout.selectFromList")}</label>
              </div>
              <div className="custom-9">
                <div className="row">
                  <div className="col-md-5">
                    <div className="form-group">
                      <label>{lang("dailySellout.personInCharge")}</label>
                      <input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="form-group">
                      <label>{lang("dailySellout.organizationName")}</label>
                      <Select
                        className="ant-select"
                        options={organizationList}
                        onChange={handleOrgChange}
                        allowClear={true}
                        loading={orgLoading}
                        labelInValue={true}
                        showSearch
                        optionFilterProp="label"
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <button
                      className="btn btn-primary m-4"
                      onClick={getEmployeeListing}
                    >
                      {lang("dailySellout.list")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      {employeeList.length > 0 && loading === false && (
        <div className="card">
          <div className="card-body">
            <p className="record-total">
              {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
              {employeeList.length} / {total}
            </p>
            <div
              className="table-responsive mb-0 hover-table max-height"
            >
              <table className="table" aria-describedby="table">
                <thead>
                  <tr>
                    <th scope="col">
                      <div className="custom-checkbox d-inline-block">
                        <input
                          type="checkbox"
                          id="tc1"
                          value="checkAll"
                          name="checkAll"
                          checked={allChecked}
                          onChange={(e) => handleCheckbox(e)}
                        />
                        <label htmlFor="tc1"></label>
                      </div>
                    </th>
                    <th
                        scope="col"
                        onClick={() =>
                            handleSortingData({
                              column: "wwid",
                              sortOrder:
                                  sortWWID === "desc" ? "asc" : "desc",
                            })
                        }
                    >
                      <div className="cursor-pointer">
                        WWID
                        <em className="bx bxs-sort-alt"></em>
                      </div>
                    </th>
                    <th
                        scope="col"
                        onClick={() =>
                            handleSortingData({
                              column: "name_kanji",
                              sortOrder:
                                  sortPersonInCharge === "desc" ? "asc" : "desc",
                            })
                        }
                    >
                      <div className="cursor-pointer">
                        {lang("dailySellout.personInCharge")}
                        <em className="bx bxs-sort-alt"></em>
                      </div>
                    </th>
                    <th
                        scope="col"
                        onClick={() =>
                            handleSortingData({
                              column: "order",
                              sortOrder:
                                  sortAffiliation === "desc" ? "asc" : "desc",
                            })
                        }
                    >
                      <div className="cursor-pointer">
                        {lang("dailySellout.affiliation")}
                        <em className="bx bxs-sort-alt"></em>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {employeeList &&
                    employeeList.length > 0 &&
                    employeeList.map((emp) => {
                      return (
                        <tr key={emp.wwid}>
                          <td>
                            <div className="custom-checkbox d-inline-block">
                              <input
                                type="checkbox"
                                id={emp.wwid}
                                name={emp.wwid}
                                value={emp.wwid}
                                checked={emp.isChecked}
                                onChange={(e) => handleCheckbox(e)}
                                key={emp.wwid}
                              />
                              <label htmlFor={emp.wwid}></label>
                            </div>
                          </td>
                          <td>{emp.wwid}</td>
                          <td>{emp.name_kanji}</td>
                          <td>{emp.org_abbr_jp}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      {loading === true && <Spinner animation="border" />}
      {noData && <div className="noData">No data found</div>}
      {employeeData.length > 0 && employeeLoading === false && (
        <div className="card">
          <div className="card-body">
            <p className="record-total">
              {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
              {employeeData.length}
            </p>
            <div
              className="table-responsive mb-0 hover-table max-height"
            >
              <table className="table" aria-describedby="table">
                <thead>
                  <tr>
                    <th scope="col">
                      <div className="custom-checkbox d-inline-block">
                        <input
                          type="checkbox"
                          id="tc1"
                          value="checkAll"
                          name="checkAll"
                          checked={allChecked}
                          onChange={(e) => handleEmployeeCheckbox(e)}
                        />
                        <label htmlFor="tc1"></label>
                      </div>
                    </th>
                    <th scope="col">
                      <div className="cursor-pointer">
                        WWID
                        <em className="bx bxs-sort-alt"></em>
                      </div>
                    </th>
                    <th scope="col">
                      <div className="cursor-pointer">
                        {lang("dailySellout.personInCharge")}
                        <em className="bx bxs-sort-alt"></em>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {employeeData &&
                    employeeData.length > 0 &&
                    employeeData.map((emp) => {
                      return (
                        <tr key={emp.wwid}>
                          <td>
                            <div className="custom-checkbox d-inline-block">
                              <input
                                type="checkbox"
                                id={emp.wwid}
                                name={emp.wwid}
                                value={emp.wwid}
                                checked={emp.isChecked}
                                onChange={(e) => handleEmployeeCheckbox(e)}
                                key={emp.wwid}
                              />
                              <label htmlFor={emp.wwid}></label>
                            </div>
                          </td>
                          <td>{emp.wwid}</td>
                          <td>{emp.name_kanji}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      {employeeLoading === true && <Spinner animation="border" />}
      {noEmployeeData && <div className="noData">No data found</div>}
      <div className="filter-actions mt-4 mb-4">
      {lazyLoading && <Spinner animation="border" />}
        {employeeList.length > 0 && (
          <>
            {/* <button className="btn btn-primary" onClick={handleSelectAll}>
                {lang("Buttons.selectAll")}
              </button> */}
            <button className="btn btn-primary" onClick={handleReset}>
              {lang("Buttons.reset")}
            </button>
            <button className="btn btn-primary" onClick={handleSelect}>
              {lang("Buttons.select")}
            </button>
            {total > LOAD_MORE_PAGE_SIZE &&  (
                  <button
                    className="btn btn-primary"
                    onClick={loadRecords}
                    disabled={(lazyLoading || employeeList.length >= total)}
                  >
                    {lang("Buttons.loadMore")}
                  </button>
                )}
          </>
        )}
        {employeeData.length > 0 && (
          <>
            <button className="btn btn-primary" onClick={handleEmployeeSelect}>
              {lang("Buttons.select")}
            </button>
          </>
        )}
        <button className="btn btn-primary" onClick={() => goToPrevious()}>
          {lang("Buttons.back")}
        </button>
      </div>
      <Modal
        size="md"
        className="withdraw-modal"
        show={showErrorMessage}
        onHide={handleCloseErrorMessage}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">No User found</div>
          <div className="buttons-group">
            <button
              className="btn btn-primary"
              onClick={handleCloseErrorMessage}
            >
              {lang("Buttons.ok")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </Home>
  );
}

export default SearchMembers;
